import React from "react";
import {
  Text,
  Title,
  Badge,
  Stack,
  Group,
  Grid,
  Switch,
  Tooltip,
  Avatar,
} from "@mantine/core";
import { isNativePayrollBid } from "./payrollSourceHelpers";

const PayrollBidRowHeader = ({
  item,
  formatter,
  cellRender,
  onHold,
  loading,
  isConfirmed,
  payrollId,
}) => {
  const bidsArray = item.bids || [];
  const nativeBidsArray = bidsArray.filter((b) =>
    isNativePayrollBid(b, payrollId),
  );
  const heldCountFromBids = nativeBidsArray.filter(
    (b) => b.status === "HOLD",
  ).length;

  const totalBidCount =
    bidsArray.length > 0 ? bidsArray.length : item.bidCount || 0;
  const nativeBidCount =
    bidsArray.length > 0
      ? nativeBidsArray.length
      : item.nativeBidCount ?? item.bidCount ?? 0;
  const poolReleasedBidCount =
    bidsArray.length > 0
      ? bidsArray.length - nativeBidsArray.length
      : item.poolReleasedBidCount || 0;
  const heldCount =
    bidsArray.length > 0 ? heldCountFromBids : item.holdCount || 0;
  const isAllHeld = heldCount === nativeBidCount && nativeBidCount > 0;
  const holdDisabled =
    loading || isConfirmed || nativeBidCount === 0;

  const isGroupWallet =
    item.wallet?.type === "GROUP" ||
    (!item.user && (!!item.userGroup || !!item.wallet?.userGroup));

  const groupName = isGroupWallet
    ? item.userGroup?.name || item.walletName || item.wallet?.name || "—"
    : null;

  const groupCode = item.userGroup?.code || null;

  const walletLabel = item.walletName || "—";

  const holdTooltip = isConfirmed
    ? "Payroll completed"
    : nativeBidCount === 0
      ? "Pool-released bids cannot be held here"
      : isAllHeld
        ? "Release all bids"
        : "Hold all bids";

  return (
    <Grid justify="space-between" align="center">
      <Grid.Col span={3}>
        {isGroupWallet ? (
          <Group noWrap>
            <Avatar radius="xl" color="violet">
              {groupName?.charAt(0)?.toUpperCase() || "G"}
            </Avatar>
            <Group spacing="xs" noWrap>
              {groupCode && (
                <Badge size="xs" p={0} radius={0} mr={0} w={50} color="violet">
                  {groupCode}
                </Badge>
              )}
              <Text lineClamp={1}>{groupName}</Text>
            </Group>
          </Group>
        ) : item.user ? (
          <div>{cellRender.User(item.user)}</div>
        ) : (
          <div>
            <Badge mb="xs">{walletLabel}</Badge>
          </div>
        )}
      </Grid.Col>
      <Grid.Col span={2}>
        <Stack align="flex-start" spacing="xs">
          <Group spacing="xs">
            <Title order={3}>{totalBidCount}</Title>
            {poolReleasedBidCount > 0 && (
              <Badge size="sm" color="teal" variant="light">
                From Pool
              </Badge>
            )}
            {heldCount > 0 && (
              <Badge size="sm" color="yellow" variant="filled">
                {heldCount} held
              </Badge>
            )}
          </Group>
          <Text size="xs" color="dimmed">
            Total bids
          </Text>
        </Stack>
      </Grid.Col>
      <Grid.Col span={3}>
        <Stack align="flex-start" spacing="xs">
          <Title order={3} color={item.totalAmount >= 0 ? "green" : "red"}>
            {formatter.currency(item.totalAmount)}
          </Title>
          <Text size="xs" color="dimmed">
            Total Amount
          </Text>
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <div onClick={(e) => e.stopPropagation()}>
          <Tooltip label={holdTooltip}>
            <Switch
              size="md"
              color="yellow"
              checked={isAllHeld}
              disabled={holdDisabled}
              onChange={(e) => onHold && onHold(item.walletId, !isAllHeld)}
              label={
                <Text size="xs" color="dimmed">
                  Hold
                </Text>
              }
            />
          </Tooltip>
        </div>
      </Grid.Col>
    </Grid>
  );
};

export default PayrollBidRowHeader;
